// Retry reads only. Never replay a checkout, payment, message or edit.
const retryable = status => [500,502,503,504].includes(status);
function delay(ms, signal) {
  return new Promise((resolve,reject)=>{
    if(signal?.aborted){reject(new DOMException('Aborted','AbortError'));return;}
    const abort=()=>{clearTimeout(timer);reject(new DOMException('Aborted','AbortError'));};
    const timer=setTimeout(()=>{signal?.removeEventListener('abort',abort);resolve();},ms);
    signal?.addEventListener('abort',abort,{once:true});
  });
}
export async function fetchRead(url, options, fetcher=fetch) {
  const attempts=(options.method||'GET').toUpperCase()==='GET'?3:1;
  for(let i=0;i<attempts;i++){
    try {
      const response=await fetcher(url,options);
      if(!retryable(response.status)||i===attempts-1)return response;
      await response.body?.cancel();
    }catch(error){if(error.name==='AbortError'||i===attempts-1)throw error;}
    await delay(350*(i+1),options.signal);
  }
}
